import { useLang } from "../lib/i18n";
import { Overline } from "../components/ui-vision";

const STR = {
  fr: {
    overline: "À propos",
    intro:
      "Vision+ est une entreprise belge spécialisée dans la fourniture et la pose de menuiseries sur mesure pour l'habitat. Nous accompagnons nos clients dans leurs projets de rénovation et de construction, partout en Belgique.",
    labels: {
      company: "Société",
      address: "Adresse",
      email: "E-mail",
      phone: "Téléphone",
      vat: "N° d'entreprise / TVA",
      zone: "Zone d'intervention",
      activity: "Activité",
    },
    zoneVal: "Toute la Belgique",
    activityVal: "Fourniture et pose de menuiseries sur mesure",
  },
  nl: {
    overline: "Over ons",
    intro:
      "Vision+ is een Belgisch bedrijf gespecialiseerd in de levering en plaatsing van schrijnwerk op maat voor woningen. Wij begeleiden onze klanten bij hun renovatie- en bouwprojecten, overal in België.",
    labels: {
      company: "Vennootschap",
      address: "Adres",
      email: "E-mail",
      phone: "Telefoon",
      vat: "Ondernemingsnr. / btw",
      zone: "Werkgebied",
      activity: "Activiteit",
    },
    zoneVal: "Heel België",
    activityVal: "Levering en plaatsing van schrijnwerk op maat",
  },
};

const MAP_SRC =
  "https://www.google.com/maps?q=Groot-Molenveldlaan%2051,%201850%20Grimbergen,%20Belgium&z=15&output=embed";

export default function APropos() {
  const { lang } = useLang();
  const s = STR[lang];

  const rows = [
    { label: s.labels.company, value: "COMEC BV" },
    {
      label: s.labels.address,
      value: (
        <>
          Groot-Molenveldlaan 51 3
          <br />
          1850 Grimbergen
        </>
      ),
    },
    {
      label: s.labels.email,
      value: (
        <a href="mailto:info@vplus.be" data-testid="about-email" className="hover:text-accent-yellow transition-colors duration-300">
          info@vplus.be
        </a>
      ),
    },
    {
      label: s.labels.phone,
      value: (
        <a href="tel:+3225885600" data-testid="about-phone" className="hover:text-accent-yellow transition-colors duration-300">
          02 588 56 00
        </a>
      ),
    },
    { label: s.labels.vat, value: "0758.412.316" },
    { label: s.labels.zone, value: s.zoneVal },
    { label: s.labels.activity, value: s.activityVal },
  ];

  return (
    <>
      <section className="pt-28 md:pt-32 pb-6 md:pb-8 max-w-[1440px] mx-auto px-6 md:px-12" data-testid="about">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8 items-stretch">
          <div className="rounded-3xl border border-white/10 bg-white/[0.03] p-8 md:p-10" data-testid="about-company-card">
            <Overline className="mb-6">{s.overline}</Overline>
            <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.05] mb-5">
              Vision+
            </h1>
            <p className="text-white/55 font-light leading-relaxed">{s.intro}</p>

            <dl className="mt-8 border-t border-white/10">
              {rows.map((r, i) => (
                <div key={i} className="py-4 border-b border-white/10">
                  <dt className="text-xs uppercase tracking-[0.25em] text-accent-yellow mb-1.5">{r.label}</dt>
                  <dd className="text-white/80 font-light leading-relaxed">{r.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div
            className="relative rounded-3xl border border-white/10 overflow-hidden h-[340px] lg:h-auto lg:min-h-[440px]"
            data-testid="about-map"
          >
            <iframe
              title="Vision+ — Grimbergen"
              src={MAP_SRC}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              style={{ border: 0, filter: "invert(0.9) hue-rotate(180deg) brightness(0.95) contrast(0.9)" }}
            />
          </div>
        </div>
      </section>
    </>
  );
}
